import { DataResult, State } from "@progress/kendo-data-query";
import axios from "axios";
import { ftlRouteUrls, pdsrUrls, spdrUrls } from "../URL/ApplicationUrls";
import { toRequestStringWithoutPage } from "./Extensions/kendoDataState";

type GetSelectedItemProps<T> = {
  selectedItemIds: number[];
  tableDataResult: DataResult;
  currentDatastate: State;
  key: keyof T;
};
export const getSelectedItemsByProperty = <T>({
  selectedItemIds,
  tableDataResult,
  key,
}: GetSelectedItemProps<T>) => {
  return tableDataResult.data.filter((item) => selectedItemIds.includes(item[key]));
};

export const getSpdrIdOriginTable = async ({
  selectedIds,
  currentDatastate,
  tableDataResult,
  allItemsSelected,
}: {
  selectedIds: number[];
  currentDatastate: State;
  tableDataResult: DataResult;
  allItemsSelected: boolean;
}) => {
  if (allItemsSelected) {
    const allSpdrIds = await axios
      .post(spdrUrls.allSpdrIdsFromFilter, toRequestStringWithoutPage(currentDatastate))
      .then((result) => {
        return result.data.map((spdrId: number) => spdrId);
      });
    return allSpdrIds as Array<number>;
  }
  return tableDataResult.data
    .filter((item) => selectedIds.includes(item.Id))
    .map((item) => item.SpdrIdOriginTable) as Array<number>;
};

export const getPdsrIdOriginTable = async ({
  selectedIds,
  currentDatastate,
  tableDataResult,
  allItemsSelected,
}: {
  selectedIds: number[];
  currentDatastate: State;
  tableDataResult: DataResult;
  allItemsSelected: boolean;
}) => {
  if (allItemsSelected) {
    const allPdsrIds = await axios
      .post(pdsrUrls.allPdsrIdsFromFilter, toRequestStringWithoutPage(currentDatastate))
      .then((result) => {
        return result.data.map((pdsrId: number) => pdsrId);
      });
    return allPdsrIds as Array<number>;
  }
  return tableDataResult.data
    .filter((item) => selectedIds.includes(item.Id))
    .map((item) => item.PdsrIdOriginTable) as Array<number>;
};

export const getFtlRouteIds = async ({
  selectedIds,
  currentDatastate,
  tableDataResult,
  allItemsSelected,
}: {
  selectedIds: number[];
  currentDatastate: State;
  tableDataResult: DataResult;
  allItemsSelected: boolean;
}) => {
  if (allItemsSelected) {
    const allRouteIds = await axios
      .post(ftlRouteUrls.allFtlRouteIdsFromFilter, toRequestStringWithoutPage(currentDatastate))
      .then((result) => {
        return result.data.map((routeId: number) => routeId);
      });
    return allRouteIds as Array<number>;
  }
  return tableDataResult.data
    .filter((item) => selectedIds.includes(item.Id))
    .map((item) => item.RouteId) as Array<number>;
};
